export default "__VITE_ASSET__cb741378__"